import { useEffect, useState } from "react";
import { Search, X } from "lucide-react";
import { api } from "@/lib/api";

const TOPICS = [
  { id: "", label: "All" },
  { id: "core", label: "Core" }, { id: "feelings", label: "Feelings" },
  { id: "people", label: "People" }, { id: "food", label: "Food" },
  { id: "body", label: "Body" }, { id: "care", label: "Care" },
  { id: "actions", label: "Actions" }, { id: "play", label: "Play" },
  { id: "places", label: "Places" }, { id: "animals", label: "Animals" },
  { id: "vehicle", label: "Vehicles" }, { id: "clothes", label: "Clothes" },
  { id: "describe", label: "Describe" }, { id: "colors", label: "Colors" },
  { id: "numbers", label: "Numbers" }, { id: "time", label: "Time" },
  { id: "weather", label: "Weather" }, { id: "social", label: "Social" },
  { id: "phrases", label: "Phrases" }, { id: "thing", label: "Things" },
  { id: "tech", label: "Tech" },
];

export default function VocabPicker({ open, onClose, onPick }) {
  const [q, setQ] = useState("");
  const [topic, setTopic] = useState("");
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (!open) return;
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/vocab-library?q=${encodeURIComponent(q)}&topic=${topic}&limit=600`);
        setItems(data.items);
        setTotal(data.total);
      } catch { /* offline ok */ }
    }, 120);
    return () => clearTimeout(t);
  }, [open, q, topic]);

  if (!open) return null;

  return (
    <div className="modal-overlay" data-testid="vocab-picker-modal">
      <div className="brutal-card p-4 w-full max-w-2xl max-h-[90vh] flex flex-col">
        <div className="flex items-center gap-2 mb-3">
          <h2 className="display text-2xl font-bold flex-1">Browse vocabulary</h2>
          <button type="button" className="pill-btn" onClick={onClose} data-testid="vocab-picker-close">
            <X size={18} />
          </button>
        </div>

        <div className="relative mb-2">
          <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-[color:var(--ink-soft)]" />
          <input
            className="brutal-input pl-10"
            placeholder="Search 500+ words…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            autoFocus
            data-testid="vocab-search-input"
          />
        </div>

        <div className="flex flex-wrap gap-1 mb-3">
          {TOPICS.map((t) => (
            <button
              key={t.id || "all"}
              type="button"
              onClick={() => setTopic(t.id)}
              className={`px-3 py-1.5 rounded-full border-[2.5px] border-[color:var(--ink)] text-sm font-semibold ${topic === t.id ? "bg-[color:var(--ink)] text-[color:var(--cream)]" : "bg-white"}`}
              data-testid={`vocab-topic-${t.id || "all"}`}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="text-sm text-[color:var(--ink-soft)] mb-2">
          {total} matching word{total === 1 ? "" : "s"}
        </div>

        <div className="flex-1 overflow-y-auto tile-scroll grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
          {items.map((w) => (
            <button
              key={`${w.label}-${w.topic}`}
              type="button"
              onClick={() => onPick(w)}
              className="tile-btn tile-sm"
              style={{ background: "#fff" }}
              data-testid={`vocab-item-${w.label}`}
            >
              <span className="tile-emoji" style={{ fontSize: "2rem" }}>{w.emoji}</span>
              <span className="tile-label">{w.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
